import type { BlockEditProps } from "@wordpress/blocks";
import { useCallback } from "react";
import Creatable from "react-select/creatable";
import type { BlockAttributes } from "./block.json";
import {
  InspectorControls,
  RichText,
  useBlockProps,
  useInnerBlocksProps,
} from "@wordpress/block-editor";
import "../slider/swiper";
import ImageEditor from "../../../source/components/ImageEditor";
import { useSelect } from "@wordpress/data";
import {
  PanelBody,
  PanelRow,
  TextControl,
  ToggleControl,
} from "@wordpress/components";

export default function TeaserEditor(props: BlockEditProps<BlockAttributes>) {
  const blockProps = useBlockProps({ className: "card" });
  const isSelected = blockProps.className?.split(" ").includes("is-selected");

  const innerBlocksProps = useInnerBlocksProps({
    className: "",
  });
  const getPageOptions = useSelect(
    (select: any) =>
      select("core").getEntityRecords("postType", "page", {
        per_page: -1,
      }),
    []
  );
  const options = getPageOptions
    ? getPageOptions.map((page: { link: any; slug: any }) => ({
        value: page.link,
        label: page.slug,
      }))
    : [];

  const handleSelectChange = (selectedOption: { value: any }) => {
    props.setAttributes({
      anchor: selectedOption.value,
      pageUrl: selectedOption.value,
    });
  };

  const {
    attributes: { extUrl = false },
    setAttributes,
  } = props;
  const setExtUrl = useCallback(
    (extUrl: boolean) => {
      setAttributes({ extUrl });
    },
    [setAttributes]
  );

  const selectedUrl = options.find(
    (option: { value: any; label: any }) =>
      option.value === props.attributes.pageUrl
  );

  const customOption = props.attributes.pageUrl &&
    !selectedUrl && {
      value: props.attributes.pageUrl,
      label: props.attributes.pageUrl,
    };
  const defaultValue = selectedUrl || customOption;
  return (
    <>
      <InspectorControls>
        <PanelBody>
          <PanelRow>
            <TextControl
              label="Button Url"
              value={props.attributes.linkUrl ?? ""}
              onChange={(newlinkUrl) =>
                props.setAttributes({ linkUrl: newlinkUrl })
              }
            />
          </PanelRow>
        </PanelBody>
      </InspectorControls>
      <div {...blockProps}>
        <ImageEditor
          attributes={props.attributes}
          setAttributes={props.setAttributes}
          prefix="image"
          placeholderClassName="img-placeholder"
        />
        <div className="background-blue card-bottom card-body d-flex flex-column justify-content-between">
          <div>
            <h3>
              <RichText
                value={props.attributes.heading ?? ""}
                onChange={(heading) => props.setAttributes({ heading })}
                placeholder="Überschrift"
              />
            </h3>
            <p>
              <RichText
                value={props.attributes.content ?? ""}
                onChange={(content) => props.setAttributes({ content })}
                placeholder="Content"
              />
            </p>
          </div>
          <div>
            <a className="button">
              <RichText
                value={props.attributes.button_text ?? ""}
                onChange={(button_text) => props.setAttributes({ button_text })}
                placeholder="Mehr erfahren"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
